<h2 mat-dialog-title>{{ data.title || 'Add Mailbox' }}</h2>
@if (data.subTitle) {
  <p class="subtitle">{{ data.subTitle }}</p>
}
<mat-dialog-content>
  <form [formGroup]="form">
    @if (isMailboxUnknown) {
      <app-input-field
        label="Server"
        placeholder="Select server"
        type="autocomplete"
        [options]="filteredServers()"
        formControlName="serverId"
        [(searchText)]="serverSearchText"
      ></app-input-field>

      <app-input-field
        label="Website"
        placeholder="Select website"
        type="autocomplete"
        [options]="(websiteOptions$ | async) || []"
        formControlName="websiteId"
        [(searchText)]="websiteSearchText"
        [errorMessages]="{
          noService:
            'This website does not have Mail Service in Vmax. To add mailboxes, create it first.',
        }"
      ></app-input-field>
    }
    @if (data.mailboxId || isMailboxUnknown) {
      <app-input-field
        label="Email Address"
        placeholder="Enter email"
        formControlName="address"
        type="text"
        [suffixText]="emailSuffix() ? '@' + emailSuffix() : ''"
        autocomplete="off"
        [errorMessages]="{ minlength: 'Valid address is required!' }"
      ></app-input-field>
    }

    <app-input-field label="Real Name" formControlName="realName" type="text"></app-input-field>

    <app-input-field
      label="Password"
      placeholder="*********"
      formControlName="password"
      type="password"
      autocomplete="new-password"
    ></app-input-field>

    <app-input-field
      label="Aliases"
      placeholder="Type in e-mail and press ENTER or COMMA"
      formControlName="aliases"
      type="chips-autocomplete"
    ></app-input-field>

    <mat-checkbox>Make this mailbox the catch-all address</mat-checkbox>

    <app-input-field
      label="Forwards to"
      placeholder="Type in e-mail and press ENTER or COMMA"
      formControlName="forwards"
      type="chips-autocomplete"
    ></app-input-field>

    <mat-checkbox formControlName="localDelivery"
      >Keep a local copy of forwarded emails</mat-checkbox
    >

    <div class="quota" formGroupName="quota">
      <div class="label">Mailbox Quota</div>
      <mat-radio-group formControlName="radio">
        <mat-radio-button value="1">
          <app-size-input formControlName="blockSoft" id="quota-input" />
        </mat-radio-button>
        <mat-radio-button value="2"
          >Up to the limit of available disk space in the hosting plan</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">
    {{ data.primaryButtonText || 'Add Mailbox' }}
  </button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
